import { render, staticRenderFns } from "./AdminManageEducationModal.vue?vue&type=template&id=6771bcfc"
import script from "./AdminManageEducationModal.vue?vue&type=script&lang=js"
export * from "./AdminManageEducationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports